// extracted by mini-css-extract-plugin
export default {"buttonSection":"ViewApplication_buttonSection__6tjUW","publishButton":"ViewApplication_publishButton__oFW+M","closeButton":"ViewApplication_closeButton__4BXUG"};